module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/timeline"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('br'), _c('span', [_vm._v("Shops")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Search")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _c('a', {
    staticClass: "col-xs-3",
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ece1ca0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/menubottom.vue
// module id = 266
// module chunks = 0